import styled from 'styled-components'
import { ThemeProps } from 'src/hook/useUser'
import { MAIN_HEADER_HEIGHT, VIEW_AS_BAR_HEADER } from 'src/utils/constants'

type DrawerProps = {
  theme: ThemeProps
  visible: boolean
  hasViewAsBar: boolean
}

export const Drawer = styled.aside<DrawerProps>`
  background-color: ${({ theme }) => (theme === 'dark' ? '#0e0f12' : 'var(--white)')};
  width: 100%;
  border-top-left-radius: var(--border-radius-lg);
  border-bottom-left-radius: var(--border-radius-lg);
  outline: none;
  top: 0;
  right: ${({ visible }) => (visible ? 0 : '-100%')};
  bottom: 0;
  z-index: 8;
  transition: right 0.3s ease-in-out;

  @media (min-width: 480px) {
    width: 24.125rem;
    top: ${({ hasViewAsBar }) =>
      hasViewAsBar ? `calc(${MAIN_HEADER_HEIGHT} + ${VIEW_AS_BAR_HEADER})` : MAIN_HEADER_HEIGHT};
    z-index: 7;
  }
`

Drawer.displayName = 'Drawer'

export const Content = styled.div`
  height: calc(100% - 11.625rem); // 11.625rem) (186px) => main header + profile header
`

Content.displayName = 'Content'
